import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "denver-metro",
    name: "Denver Metro",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Denver Core & Cherry Creek",
        description: "Downtown Denver, Capitol Hill, LoDo, Cherry Creek, and the Golden Triangle. Denver International (DEN) is 25 miles northeast on the A-Line train. The 6th Avenue and I-25 corridors connect to all metro suburbs.",
        hub: { name: "Denver", route: "/cities/denver" },
        communities: [
          { name: "Capitol Hill", route: "#" }, { name: "LoDo", route: "#" },
          { name: "Cherry Creek", route: "#" }, { name: "Golden Triangle", route: "#" },
          { name: "Uptown", route: "#" }, { name: "Highland", route: "#" },
          { name: "LoHi", route: "#" }, { name: "Berkeley", route: "#" },
          { name: "Sunnyside", route: "#" }, { name: "Stapleton", route: "#" },
          { name: "Central Park", route: "#" }, { name: "Montclair", route: "#" },
          { name: "Glendale", route: "#" }, { name: "Englewood", route: "#" },
        ],
      },
      {
        name: "Arapahoe County — Aurora & Centennial",
        description: "Aurora is Denver's eastern counterpart. Centennial and Greenwood Village are south on the 470 loop. The Fitzsimons medical campus and Buckley Space Force Base are in Aurora. I-225 and the 470 connect to DEN.",
        hub: { name: "Aurora", route: "/cities/aurora-co" },
        communities: [
          { name: "Centennial", route: "/cities/centennial" }, { name: "Greenwood Village", route: "#" },
          { name: "Parker", route: "/cities/parker" }, { name: "Littleton", route: "/cities/littleton" },
          { name: "Sheridan", route: "#" }, { name: "Cherry Hills Village", route: "#" },
          { name: "Foxfield", route: "#" }, { name: "Foxborough", route: "#" },
          { name: "Hoffman Heights", route: "#" }, { name: "Sable Ridge", route: "#" },
          { name: "Hutchinson Heights", route: "#" }, { name: "Southshore", route: "#" },
          { name: "Meadow Hills", route: "#" }, { name: "Sterling Hills", route: "#" },
        ],
      },
      {
        name: "Adams & Jefferson County — North & West",
        description: "Westminster, Thornton, Arvada, Lakewood, and Golden are north and west of Denver. The 6th Avenue corridor connects to the mountains. Jefferson County is the gateway to Red Rocks, Lookout Mountain, and I-70.",
        hub: { name: "Westminster", route: "/cities/westminster-co" },
        communities: [
          { name: "Thornton", route: "#" }, { name: "Arvada", route: "/cities/arvada" },
          { name: "Lakewood", route: "/cities/lakewood-co" }, { name: "Golden", route: "/cities/golden" },
          { name: "Wheat Ridge", route: "/cities/wheat-ridge" }, { name: "Northglenn", route: "/cities/northglenn" },
          { name: "Broomfield", route: "/cities/broomfield" }, { name: "Brighton", route: "/cities/brighton" },
          { name: "Commerce City", route: "/cities/commerce-city" }, { name: "Federal Heights", route: "/cities/federal-heights" },
          { name: "Mountain View", route: "#" }, { name: "Lakeside", route: "#" },
          { name: "Edgewater", route: "#" }, { name: "Superior", route: "#" },
        ],
      },
      {
        name: "Douglas County — South Metro",
        description: "Castle Rock, Highlands Ranch, and Lone Tree are south of the 470. Douglas County is one of Colorado's fastest-growing areas. The Lincoln/C470 corridor is the main artery. Sedalia and Larkspur are the foothill communities.",
        hub: { name: "Castle Rock", route: "/cities/castle-rock" },
        communities: [
          { name: "Highlands Ranch", route: "/cities/highlands-ranch" }, { name: "Lone Tree", route: "/cities/lone-tree" },
          { name: "Parker", route: "/cities/parker" }, { name: "Roxborough", route: "#" },
          { name: "Sedalia", route: "#" }, { name: "Larkspur", route: "#" },
          { name: "Franktown", route: "#" }, { name: "Perry Park", route: "#" },
          { name: "Crystal Valley", route: "#" }, { name: "The Meadows", route: "#" },
          { name: "Backcountry", route: "#" }, { name: "Keene Ranch", route: "#" },
          { name: "Pinery", route: "#" }, { name: "Cottonwood", route: "#" },
        ],
      },
    ],
  },
  {
    id: "front-range",
    name: "Front Range",
    icon: "ri-road-map-line",
    subregions: [
      {
        name: "Boulder County",
        description: "Boulder, Longmont, Lafayette, and Louisville are the Boulder County core. The University of Colorado Boulder creates a large student population. The 36 and 119 connect to Denver. Nederland and Lyons are the mountain communities.",
        hub: { name: "Boulder", route: "/cities/boulder" },
        communities: [
          { name: "Longmont", route: "/cities/longmont" }, { name: "Lafayette", route: "/cities/lafayette-co" },
          { name: "Louisville", route: "/cities/louisville-co" }, { name: "Erie", route: "/cities/erie-co" },
          { name: "Nederland", route: "#" }, { name: "Lyons", route: "#" },
          { name: "Jamestown", route: "#" }, { name: "Ward", route: "#" },
          { name: "Allenspark", route: "#" }, { name: "Gunbarrel", route: "#" },
          { name: "Niwot", route: "#" }, { name: "Hygiene", route: "#" },
          { name: "Mead", route: "#" }, { name: "Frederick", route: "#" },
        ],
      },
      {
        name: "Northern Colorado — Fort Collins & Greeley",
        description: "Fort Collins, Loveland, Greeley, and Windsor are the northern corridor. Colorado State University is in Fort Collins. The 25 and 85 connect to Denver. Estes Park is the gateway to Rocky Mountain National Park.",
        hub: { name: "Fort Collins", route: "/cities/fort-collins" },
        communities: [
          { name: "Loveland", route: "/cities/loveland" }, { name: "Greeley", route: "/cities/greeley" },
          { name: "Windsor", route: "#" }, { name: "Timnath", route: "#" },
          { name: "Severance", route: "#" }, { name: "Johnstown", route: "#" },
          { name: "Berthoud", route: "#" }, { name: "Wellington", route: "#" },
          { name: "Estes Park", route: "#" }, { name: "Red Feather Lakes", route: "#" },
          { name: "Livermore", route: "#" }, { name: "Laporte", route: "#" },
          { name: "Poudre Canyon", route: "#" }, { name: "Drake", route: "#" },
        ],
      },
      {
        name: "Colorado Springs & Pikes Peak",
        description: "Colorado Springs, Pueblo, Fountain, and Manitou Springs. The Air Force Academy, Fort Carson, and Peterson SFB are all here. The Garden of the Gods and Pikes Peak are the major landmarks. I-25 is the main corridor.",
        hub: { name: "Colorado Springs", route: "/cities/colorado-springs" },
        communities: [
          { name: "Pueblo", route: "/cities/pueblo" }, { name: "Fountain", route: "/cities/fountain" },
          { name: "Manitou Springs", route: "#" }, { name: "Woodland Park", route: "#" },
          { name: "Monument", route: "#" }, { name: "Palmer Lake", route: "#" },
          { name: "Cripple Creek", route: "#" }, { name: "Victor", route: "#" },
          { name: "Green Mountain Falls", route: "#" }, { name: "Cascade", route: "#" },
          { name: "Chipita Park", route: "#" }, { name: "Cimarron Hills", route: "#" },
          { name: "Security", route: "#" }, { name: "Widefield", route: "#" },
        ],
      },
    ],
  },
  {
    id: "mountain-resorts",
    name: "Mountain Resorts",
    icon: "ri-snowflake-line",
    subregions: [
      {
        name: "I-70 Corridor — Summit to Eagle",
        description: "Vail, Avon, Eagle, and Minturn are the Vail Valley core. The I-70 corridor is Colorado's main east-west artery. These are high-altitude resort communities with seasonal populations and international travelers.",
        hub: { name: "Vail", route: "/cities/vail" },
        communities: [
          { name: "Avon", route: "#" }, { name: "Edwards", route: "#" },
          { name: "Eagle", route: "#" }, { name: "Minturn", route: "#" },
          { name: "Red Cliff", route: "#" }, { name: "Gypsum", route: "#" },
          { name: "Basalt", route: "#" }, { name: "El Jebel", route: "#" },
          { name: "Carbondale", route: "#" }, { name: "Glenwood Springs", route: "#" },
          { name: "No Name", route: "#" }, { name: "Dotsero", route: "#" },
          { name: "Wolcott", route: "#" }, { name: "Bond", route: "#" },
        ],
      },
      {
        name: "Breckenridge & Summit County",
        description: "Breckenridge, Frisco, Silverthorne, and Dillon are the Summit County core. The Eisenhower Tunnel and Vail Pass are the major I-70 crossings. Keystone and Copper Mountain are the major ski resorts. These are 70–90 minutes from Denver.",
        hub: { name: "Breckenridge", route: "/cities/breckenridge" },
        communities: [
          { name: "Frisco", route: "#" }, { name: "Silverthorne", route: "#" },
          { name: "Dillon", route: "#" }, { name: "Keystone", route: "#" },
          { name: "Copper Mountain", route: "#" }, { name: "Blue River", route: "#" },
          { name: "Montezuma", route: "#" }, { name: "Heeney", route: "#" },
          { name: "Alma", route: "#" }, { name: "Fairplay", route: "#" },
          { name: "Como", route: "#" }, { name: "Jefferson", route: "#" },
          { name: "Grant", route: "#" }, { name: "Leadville", route: "#" },
        ],
      },
      {
        name: "Aspen & Roaring Fork Valley",
        description: "Aspen, Snowmass Village, and Basalt are the Roaring Fork Valley. Aspen-Pitkin County Airport (ASE) is the local airport. The Maroon Bells are the iconic backdrop. Glenwood Springs is the lower valley hub.",
        hub: { name: "Aspen", route: "/cities/aspen" },
        communities: [
          { name: "Snowmass Village", route: "#" }, { name: "Basalt", route: "#" },
          { name: "El Jebel", route: "#" }, { name: "Carbondale", route: "#" },
          { name: "Glenwood Springs", route: "#" }, { name: "Redstone", route: "#" },
          { name: "Marble", route: "#" }, { name: "Crystal", route: "#" },
          { name: "Crested Butte", route: "#" }, { name: "Mt Crested Butte", route: "#" },
          { name: "Gunnison", route: "#" }, { name: "Pitkin", route: "#" },
          { name: "Twin Lakes", route: "#" }, { name: "Buena Vista", route: "#" },
        ],
      },
      {
        name: "Steamboat & Telluride",
        description: "Steamboat Springs is in Routt County. The Strawberry Park Hot Springs are a local attraction. Telluride is in San Miguel County with Mountain Village as the companion resort. The Million Dollar Highway connects.",
        hub: { name: "Steamboat Springs", route: "/cities/steamboat-springs" },
        communities: [
          { name: "Oak Creek", route: "#" }, { name: "Yampa", route: "#" },
          { name: "Phippsburg", route: "#" }, { name: "Clark", route: "#" },
          { name: "Hayden", route: "#" }, { name: "Craig", route: "#" },
          { name: "Mountain Village", route: "#" }, { name: "Ridgway", route: "#" },
          { name: "Ouray", route: "#" }, { name: "Silverton", route: "#" },
          { name: "Dolores", route: "#" }, { name: "Mancos", route: "#" },
          { name: "Bayfield", route: "#" }, { name: "Telluride", route: "/cities/telluride" },
        ],
      },
    ],
  },
  {
    id: "western-slope",
    name: "Western Slope",
    icon: "ri-compass-line",
    subregions: [
      {
        name: "Grand Junction & Mesa County",
        description: "Grand Junction is the Western Slope's largest city. Fruita, Clifton, and Palisade are the surrounding communities. The Colorado National Monument is the landmark. The Grand Mesa is the world's largest flat-top mountain.",
        hub: { name: "Grand Junction", route: "/cities/grand-junction" },
        communities: [
          { name: "Fruita", route: "#" }, { name: "Clifton", route: "#" },
          { name: "Palisade", route: "#" }, { name: "Orchard Mesa", route: "#" },
          { name: "Redlands", route: "#" }, { name: "Mack", route: "#" },
          { name: "Loma", route: "#" }, { name: "De Beque", route: "#" },
          { name: "Collbran", route: "#" }, { name: "Mesa", route: "#" },
          { name: "Molina", route: "#" }, { name: "Whitewater", route: "#" },
          { name: "Gateway", route: "#" }, { name: "Glade Park", route: "#" },
        ],
      },
      {
        name: "Durango & Southwest Colorado",
        description: "Durango is the Four Corners gateway. Farmington, NM is the closest larger city. The Durango & Silverton Narrow Gauge Railroad is the attraction. Mesa Verde National Park is nearby. US-550 is the major corridor.",
        hub: { name: "Durango", route: "/cities/durango" },
        communities: [
          { name: "Bayfield", route: "#" }, { name: "Ignacio", route: "#" },
          { name: "Silverton", route: "#" }, { name: "Cortez", route: "#" },
          { name: "Mancos", route: "#" }, { name: "Dolores", route: "#" },
          { name: "Towaoc", route: "#" }, { name: "Shiprock", route: "#" },
          { name: "Aztec", route: "#" }, { name: "Bloomfield", route: "#" },
          { name: "Kirtland", route: "#" }, { name: "Farmington", route: "#" },
          { name: "Pagosa Springs", route: "#" }, { name: "Chimney Rock", route: "#" },
        ],
      },
    ],
  },
];

export default function ColoradoCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across Colorado
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every Colorado community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                {sub.hub.route !== "#" ? (
                  <a
                    href={sub.hub.route}
                    className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                  >
                    Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                  </a>
                ) : (
                  <span className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                    Hub: {sub.hub.name}
                  </span>
                )}
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  c.route !== "#" ? (
                    <a
                      key={j}
                      href={c.route}
                      className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                    >
                      {c.name}
                    </a>
                  ) : (
                    <span
                      key={j}
                      className="inline-flex items-center text-xs font-medium text-[#6B7280] bg-white border border-gray-200 rounded-full px-3 py-1 whitespace-nowrap"
                    >
                      {c.name}
                    </span>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of Colorado.
        </p>
      </div>
    </section>
  );
}